export default __webpack_public_path__ + "static/applet-13-set-2-05bd92a97ab231e73178ee66b1e56726.webp";